import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers, tabs } from "./config";

const SyncedShipmentList = () => {

  return (
    <Table tableId="synced_shipments" title="Novotracker Shipment" icon={InventoryRoundedIcon} headers={headers} tabs={tabs} filters={filters} defaultSort="-date_created" idKey="nt_shipment_id" tabField="shipment_type" createNew={false} edit={false} />
  );
};

export default SyncedShipmentList;